import MultilineCommand from "./MultilineCommand";

export default MultilineCommand;
